var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScheduleAppointmentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_34",
    "data-name": "Group 34",
    transform: "translate(-212 -248)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "appointment-new-svgrepo-com",
    d: "M31.575,18.483a1.382,1.382,0,0,0-1.386,1.386V26.8H26.03a1.386,1.386,0,1,0,0,2.772h5.545a1.382,1.382,0,0,0,1.386-1.386V19.869A1.382,1.382,0,0,0,31.575,18.483Z",
    transform: "translate(198.446 237.835)",
    fill: "#081831"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_4",
    "data-name": "Subtraction 4",
    d: "M18,36A18,18,0,0,1,10.994,1.415,18,18,0,0,1,25.007,34.586,17.889,17.889,0,0,1,18,36ZM18,5.4A12.6,12.6,0,1,0,30.6,18,12.614,12.614,0,0,0,18,5.4Z",
    transform: "translate(212 248)",
    fill: "#081831"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduleAppointmentIcon);
export default __webpack_public_path__ + "static/media/scheduleAppointmentIcon.a7432c7f2eee8a035ac8f8f352b12d79.svg";
export { ForwardRef as ReactComponent };